// extracted by mini-css-extract-plugin
export default {"container":"Pluses_container__mY2QS","cardsContainer":"Pluses_cardsContainer__cyoEv"};